// File: src/app/shared/services/auth.guard.ts
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth-service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const maybeAuth = this.authService.isAuthenticated();

    // synchronous boolean
    if (typeof maybeAuth === 'boolean') {
      if (maybeAuth) return true;
      return this.router.createUrlTree(['/login'])//, { queryParams: { returnUrl: state.url } }
    }

    // Promise
    if (maybeAuth && typeof (maybeAuth as any).then === 'function') {
      return (maybeAuth as Promise<boolean>).then(auth => (auth ? true : this.router.createUrlTree(['/login'])))//, { queryParams: { returnUrl: state.url } })));
    }


    return (maybeAuth as Observable<boolean>).pipe(
      take(1),
      map(auth => (auth ? true : this.router.createUrlTree(['/login'])))//, { queryParams: { returnUrl: state.url } })))
    );
  }
}